import { createFileRoute } from '@tanstack/react-router';
import { OnboardingPage } from '@/components/finance/onboarding';

// FSU shell unification: setup absorbed under the Settings sub-nav.
export const Route = createFileRoute('/admin/finance/settings/setup')({
  component: OnboardingPage,
});
